import { useInfo } from "./WithInfo";

export const HeaderLogo: React.FC = () => {
  const info = useInfo();
  return <img className="h-7" src={info?.configuration.logo ?? ""} />;
};
